import { MigrationScheduleContent } from '@/components/layout/oci-migration-notice/migration-schedule/content'
import {
  MigrationNotesFallback,
  MigrationScheduleFallback,
} from '@/components/layout/oci-migration-notice/migration-schedule/fallback'
import { ScheduleNotes } from '@/components/layout/oci-migration-notice/migration-schedule/schedule-notes'
import { COMPANY_MIGRATION_SCHEDULE_QUERY } from '@/components/layout/oci-migration-notice/queries'
import { QueryErrorBoundary } from '@/components/shared/error-boundary-overlay/query-error-boundary'
import { useIdCompany } from '@/lib/hooks'

type MigrationScheduleProps = {
  waveLabel: string
}

export const MigrationSchedule = ({ waveLabel }: MigrationScheduleProps) => {
  const { idCompany } = useIdCompany()

  if (!idCompany) {
    return null
  }

  return (
    <QueryErrorBoundary
      queries={[COMPANY_MIGRATION_SCHEDULE_QUERY]}
      fallback={<MigrationScheduleFallback />}
    >
      <MigrationScheduleContent idCompany={idCompany} waveLabel={waveLabel} />
    </QueryErrorBoundary>
  )
}

export const MigrationNotes = ({ waveLabel }: MigrationScheduleProps) => {
  const { idCompany } = useIdCompany()

  if (!idCompany) {
    return null
  }

  return (
    <QueryErrorBoundary
      queries={[COMPANY_MIGRATION_SCHEDULE_QUERY]}
      fallback={<MigrationNotesFallback />}
    >
      <ScheduleNotes idCompany={idCompany} waveLabel={waveLabel} />
    </QueryErrorBoundary>
  )
}
